import { dateToValue, valueToDate } from '../utils/helpers/helpers.reports'
import ImprovedDatePicker from './fields/ImprovedDatePicker'

interface DatePickerProps {
  fromDate: string
  toDate: string
  setFromDate: (date: string) => void
  setToDate: (date: string) => void
  type?: 'date' | 'month'
  minDate?: Date
  maxDate?: Date
}

export function DatePicker({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  type = 'date',
  minDate,
  maxDate,
}: DatePickerProps) {
  const fromDateValue = valueToDate(fromDate, type)
  const toDateValue = valueToDate(toDate, type)
  const fromMaxDate = maxDate && maxDate < toDateValue ? maxDate : toDateValue
  const toMinDate = minDate && minDate > fromDateValue ? minDate : fromDateValue

  return (
    <div className="flex flex-row gap-2 w-full md:w-auto">
      <div className="flex flex-col gap-1 text-sm text-secondaryText flex-1 md:flex-none">
        <label htmlFor="report-from-date">Fra</label>
        <ImprovedDatePicker
          id="report-from-date"
          selected={valueToDate(fromDate, type)}
          language="nb"
          type={type}
          minDate={minDate}
          maxDate={fromMaxDate}
          onChange={(date) => date && setFromDate(dateToValue(date, type))}
        />
      </div>
      <div className="flex flex-col gap-1 text-sm text-secondaryText flex-1 md:flex-none">
        <label htmlFor="report-to-date">Til</label>
        <ImprovedDatePicker
          id="report-to-date"
          selected={valueToDate(toDate, type)}
          language="nb"
          type={type}
          minDate={toMinDate}
          maxDate={maxDate}
          onChange={(date) => date && setToDate(dateToValue(date, type))}
        />
      </div>
    </div>
  )
}
